import { render, staticRenderFns } from "./exhibition-business-expand.vue?vue&type=template&id=163effc6&scoped=true&"
import script from "./exhibition-business-expand.vue?vue&type=script&lang=js&"
export * from "./exhibition-business-expand.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-business-expand.vue?vue&type=style&index=0&id=163effc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163effc6",
  null
  
)

export default component.exports